import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedUiModule } from '@cp/ui/shared-ui.module';
import { RouterLink } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HighlightPipe } from './pipes/highlight.pipe';
import { PayRatesTouchlessComponent } from './components/pay-rates-touchless/pay-rates-touchless.component';
import { IsExpiredDocumentPipe } from './pipes/is-expired-document.pipe';
import { IsValidDatePipe } from './pipes/is-valid-date.pipe';
import { IsSameDayPipe } from './pipes/is-same-day.pipe';
import { ShowLastModifiedPipe } from './pipes/show-last-modified.pipe';
import { ComplianceStatusComponent } from './components/compliance-status/compliance-status.component';
import { NotificationsEffects } from './+state/notifications.effects';
import { NotificationComponent } from './components/notification/notification.component';
import { BaseNotificationComponent } from './components/notifications/base-notification.component';
import { ComplianceExpiredNotificationComponent } from './components/notifications/compliance-expired-notification/compliance-expired-notification.component';
import { ComplianceDueToExpireNotificationComponent } from './components/notifications/compliance-due-to-expire-notification/compliance-due-to-expire-notification.component';
import { ComplianceLapsedNotificationComponent } from './components/notifications/compliance-lapsed-notification/compliance-lapsed-notification.component';
import { BookWelcomeCallComponent } from './components/book-welcome-call/book-welcome-call.component';
import { AuthenticatedHealthyEffects } from './+state/authenticated-healthy.effects';
import { RouterEffects } from './+state/router.effects';
import { TrainingCancelledNotificationComponent } from './components/notifications/training-cancelled-notification/training-cancelled-notification.component';
import { PayRatesComponent } from './components/pay-rates/pay-rates.component';
import * as fromNotification from './+state/notification.reducer';

@NgModule({
  imports: [
    CommonModule,
    SharedUiModule,
    EffectsModule.forFeature([
      NotificationsEffects,
      RouterEffects,
      AuthenticatedHealthyEffects,
    ]),
    StoreModule.forFeature(
      'notification',
      fromNotification.notificationReducer,
    ),
    RouterLink,
    NgOptimizedImage,
  ],
  declarations: [
    ComplianceStatusComponent,
    NotificationComponent,
    BaseNotificationComponent,
    ComplianceExpiredNotificationComponent,
    ComplianceDueToExpireNotificationComponent,
    ComplianceLapsedNotificationComponent,
    PayRatesComponent,
    PayRatesTouchlessComponent,
    TrainingCancelledNotificationComponent,
    BookWelcomeCallComponent,
    ShowLastModifiedPipe,
    IsSameDayPipe,
    IsValidDatePipe,
    IsExpiredDocumentPipe,
    HighlightPipe,
  ],
  exports: [
    ComplianceStatusComponent,
    NotificationComponent,
    PayRatesComponent,
    BookWelcomeCallComponent,
    IsSameDayPipe,
    ShowLastModifiedPipe,
    IsValidDatePipe,
    PayRatesTouchlessComponent,
    HighlightPipe,
  ],
})
export class CompliancePortalSharedModule {}
